<template>
  <dl>
    <dt>
      {{optionItem.menuOptionName}}
      <span class='requTxt point1'>
        {{
          (optionItem.optionMin ? $t('Detail.minimum') + ' ' + optionItem.optionMin + $t('Detail.count') + ' ' : '') +
          (optionItem.optionMin && optionItem.optionMin ? '- ' : '') +
          (optionItem.optionMax ? $t('Detail.maximum') + ' ' + optionItem.optionMax + $t('Detail.count') + ' ' : '') + $t('optional')
        }}
      </span>
    </dt>
    <!-- 세부옵션-->
    <dd>
      <ul class='ul'>
        <li v-for='(detailOption, index) in optionItem.detailOption' :key='detailOption.menuDetailOptionCode'>
          <label class='label'>
            <input
              :type='mandatoryOption?"radio":"checkbox"'
              :class='mandatoryOption?"rdo":"chk"'
              :name='optionItem.menuOptionCode'
              :disabled ="detailOption.soldOutFlag == 1"
              @click='addDetailOption($event, detailOption, index)'/>
            <span class='ico'></span>
            <span class='lTxt'>{{detailOption.menuDetailOptionName}}</span>
          </label>
          <div class="soldout" v-if="detailOption.soldOutFlag">({{$t('soldOut')}})</div>
          <div class='txt' v-else> + {{formatComma(detailOption.price)}}{{$t('MoneyUnit')}}
          </div>
        </li>
      </ul>
    </dd>
  </dl>
</template>
<script lang="js">
import { MANDATORY_OPTION_FLAG } from '@/utils/Code'
import { NORMAL_OPTION } from '@/utils/EndPoint'
import { ABLE_CHOOSE_ONLY_ONE_OPTION_MSG } from '@/utils/Message'
import Vue from 'vue'
export default Vue.extend({
  name: NORMAL_OPTION,
  props: ['optionItem', 'optionalOptions', 'optionalCheckBoxList', 'price'],
  data () {
    return {
      mandatoryOption: this.optionItem.mandatoryFlag === MANDATORY_OPTION_FLAG,
      checkBoxFlag: [] // 체크박스 체크 여부를 담는 배열
    }
  },
  created () {
    this.optionItem.detailOption.forEach(() => {
      // 체크 박스 초기화
      this.checkBoxFlag.push(false)
    })
  },
  methods: {
    setCheckBoxItem () {
      // 주문 또는 카트 담기를 할 경우 선택옵션별 최소 개수를 판별할 때 사용할 배열 생성

      // 최소 개수가 0인 경우 검사할 필요 없음
      if (this.optionItem.optionMin === 0) return

      let cnt = 0
      this.checkBoxFlag.forEach((item) => { if (item) cnt++ })

      // isValidFlag: 사용자가 선택한 개수와 최소 개수를 비교하여 true / false
      const index = this.optionalCheckBoxList.findIndex(item => item.menuOptionCode === this.optionItem.menuOptionCode)
      this.optionalCheckBoxList[index] = { ...this.optionalCheckBoxList[index], isValidFlag: this.optionItem.optionMin > cnt }
    },
    validOptional () {
      // 체크박스 최대 개수 선택 유무를 확인하기 위한 함수
      let cnt = 0
      this.checkBoxFlag.forEach((item) => { if (item) cnt++ })

      if (this.optionItem.optionMax === cnt) {
        // 최대 개수만큼 선택한 경우
        return true
      }
      return false
    },
    optionalOption (event, detailOption, index) {
      // 체크박스 설정한 경우
      if (event.target.checked) {
        // 체크박스 검사
        if (this.validOptional()) {
          event.target.checked = false
          this.toast(this, `최대 ${this.optionItem.optionMax}개만 선택 가능합니다.`)
          return
        }

        this.checkBoxFlag[index] = true
        this.optionalOptions[detailOption.menuDetailOptionCode] = { ...this.optionItem, detailOption: detailOption }
      } else {
        this.checkBoxFlag[index] = false
        delete this.optionalOptions[detailOption.menuDetailOptionCode]
      }

      // optionalCheckBoxList => 주문 또는 카트 담기 시 사용할 배열 업데이트
      this.setCheckBoxItem()

      this.$emit('update:price', this.price + (detailOption.price * (event.target.checked ? 1 : -1)))
    },
    addDetailOption (event, detailOption, index) {
      this.optionalOption(event, detailOption, index)
    }
  }
})
</script>
